"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _validation = require("../validation");

var _collections = require("../collections");

var _tnUtils = require("@thinknimble/tn-utils");

var _fields = require("./fields");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Model = /*#__PURE__*/function () {
  function Model() {
    var kwargs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, Model);
    // Collect the fields defined as static properties into
    // a private `_fields` object.
    this._fields = this.constructor.getFields(); // Loop over fields and assign kwarg values to this instance

    for (var fieldName in this._fields) {
      var field = this._fields[fieldName];
      this[fieldName] = field.clean(kwargs[fieldName]);
    }
  } // Gather `static` fields


  (0, _createClass2["default"])(Model, [{
    key: "duplicate",
    value: function duplicate() {
      var fields = {};
      var modelFields = {};

      for (var prop in this) {
        if (prop !== '_fields' && this._fields[prop]) {
          if (this._fields[prop] instanceof _fields.ModelField && (0, _validation.notNullOrUndefined)(this[prop])) {
            if (Array.isArray(this[prop]) || this._fields[prop].many) {
              modelFields[prop] = this[prop].map(function (field) {
                return field.duplicate();
              });
            } else {
              modelFields[prop] = this[prop].duplicate();
            }
          } else {
            fields[prop] = this[prop];
          }
        }
      }

      var copy = new this.constructor(fields);
      Object.entries(modelFields).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        copy[key] = val;
      });
      return copy;
    }
  }, {
    key: "newCopy",
    value: function newCopy() {
      var fields = {};
      var modelFields = {};

      for (var prop in this) {
        if (prop !== '_fields' && this._fields[prop] && !this._fields[prop].unique && (0, _validation.notNullOrUndefined)(this[prop])) {
          if (this._fields[prop] instanceof _fields.ModelField) {
            if (Array.isArray(this[prop]) || this._fields[prop].many) {
              modelFields[prop] = this[prop].map(function (field) {
                return field.newCopy();
              });
            } else {
              modelFields[prop] = this[prop].newCopy();
            }
          } else {
            fields[prop] = this[prop];
          }
        }
      }

      var copy = new this.constructor(fields);
      Object.entries(modelFields).forEach(function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            key = _ref4[0],
            val = _ref4[1];

        copy[key] = val;
      });
      return copy;
    }
  }, {
    key: "toDict",
    value: function toDict() {
      var returnFields = {};

      for (var prop in this) {
        if (prop !== '_fields' && this._fields[prop]) {
          if (this._fields[prop] instanceof _fields.ModelField && (0, _validation.notNullOrUndefined)(this[prop])) {
            if (Array.isArray(this[prop]) || this._fields[prop].many) {
              returnFields[prop] = this[prop].map(function (field) {
                return field.toDict();
              });
            } else {
              returnFields[prop] = this[prop].toDict();
            }
          } else {
            returnFields[prop] = this[prop];
          }
        }
      }

      return returnFields;
    }
    /**
     * Create a Collection for current ModelClass.
     * @param {Object} opts collection options, such as filters.
     * @returns {CollectionManager}
     */

  }], [{
    key: "getFields",
    value: function getFields() {
      var fields = {};

      for (var prop in this) {
        if (this[prop] instanceof _fields.Field) {
          fields[prop] = this[prop];
        }
      }

      return fields;
    } // Gather read-only fields

  }, {
    key: "getReadOnlyFields",
    value: function getReadOnlyFields() {
      //
      var legacyReadOnlyFields = this.readOnlyFields ? this.readOnlyFields : []; //

      var readOnlyFields = [];

      for (var _i = 0, _Object$entries = Object.entries(this.getFields()); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (value.readOnly === true) {
          readOnlyFields.push(key);
        }
      }

      return [].concat((0, _toConsumableArray2["default"])(legacyReadOnlyFields), readOnlyFields);
    }
    /**
     * Static Factory Methods
     *
     * Because these are `static`, `this === SubClass`, which means
     * that `new this()` will invoke the constructor of the subclass,
     * giving us a new instance of type `SubClass`!
     */

  }, {
    key: "create",
    value: function create() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new this(opts);
    }
  }, {
    key: "fromAPI",
    value: function fromAPI() {
      var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new this((0, _tnUtils.objectToCamelCase)(json));
    }
    /**
     * To API Method
     *
     * Convert an instance of this class to a plain old JavaScript object
     * suitable for JSON serialization and submitting to the API.
     */

  }, {
    key: "toAPI",
    value: function toAPI(obj) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      // By default, send the whole object
      var data = {}; // If it's a partial update, get only the fields specified

      if (fields.length > 0) {
        fields.forEach(function (field) {
          data[field] = obj[field];
        });
      } else {
        data = _objectSpread({}, obj);
      } // Delete private '_fields' member


      delete data['_fields']; // format it the way it is expected

      Object.keys(data).forEach(function (k) {
        if (data[k] instanceof Model || Array.isArray(data[k]) && data[k].length && data[k][0] instanceof Model) {
          data[k] = Array.isArray(data[k]) ? data[k].map(function (value) {
            return value.constructor.toAPI(value);
          }) : data[k] = data[k].constructor.toAPI(data[k]);
        }
      }); // Remove read only and excluded fields

      var mergedFields = [].concat((0, _toConsumableArray2["default"])(this.getReadOnlyFields()), (0, _toConsumableArray2["default"])(excludeFields));
      mergedFields.forEach(function (item) {
        delete data[item];
      });
      return (0, _tnUtils.objectToSnakeCase)(data);
    }
  }, {
    key: "createCollection",
    value: function createCollection(opts) {
      return _collections.CollectionManager.create(_objectSpread({}, opts, {
        ModelClass: this
      }));
    }
  }]);
  return Model;
}();

exports["default"] = Model;